import { render, staticRenderFns } from "./shopmemberdetail.vue?vue&type=template&id=0db30b0e&scoped=true&"
import script from "./shopmemberdetail.vue?vue&type=script&lang=js&"
export * from "./shopmemberdetail.vue?vue&type=script&lang=js&"
import style0 from "./shopmemberdetail.vue?vue&type=style&index=0&id=0db30b0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db30b0e",
  null
  
)

export default component.exports